import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MBOTColorLogo from "../../assets/authentication/MBOTColorLogo.png";
import { deactivateForgotPassword } from "../../redux/slices/authSlice";

const DeactivateForgotPassword = () => {
  const loading = useSelector((state) => state.auth.loading);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    dispatch(deactivateForgotPassword({ token: params?.token, navigate }));
  }, []);

  return (
    // Container for the activate account screen
    <div className="bg-blue-10 email-verification-outer-container center-alignment">
      {/* White background container for the activate account content */}
      <div className="email-verification-inner-container m-2 center-alignment flex-column rounded">
        {/* MBOTColorLogo */}
        <img src={MBOTColorLogo} alt="MBOT Logo" />
        {loading && (
          // Show loader if loading
          <section className="text-center my-5 center-alignment gap-2">
            <span className="primary-loader mt-2"></span>
            <span className="fs-20">Deactivating...</span>
          </section>
        )}
      </div>
    </div>
  );
};

export default DeactivateForgotPassword;
